module.exports = __webpack_public_path__ + "img/grid-fill.7b89edfc.svg";